import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpContextToken
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {ErrorMessageService} from '../services/error-message.service';

/** Set on background requests (session poll) so network/5xx errors are logged but not toasted. */
export const SUPPRESS_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private errorMessageService: ErrorMessageService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const suppressToast = req.context.get(SUPPRESS_ERROR_TOAST);
        console.error('HTTP Error:', {
          status: error.status,
          statusText: error.statusText,
          url: error.url,
          message: error.message,
          error: error.error
        });

        // Handle specific error codes
        switch (error.status) {
          case 401:
            // Unauthorized - redirect to home
            this.errorMessageService.showGenericPermanentError("Unauthorized.");
            setTimeout(() => {
              window.location.href = '/';
            }, 100);
            break;

          case 403:
            var msg = error?.error?.error || 'Not Allowed';
            this.errorMessageService.showGenericPermanentError(msg);
            console.warn("403 Forbidden: ", error || "")
            break;

          case 0:
            if (!suppressToast) {
              this.errorMessageService.showGenericPermanentError("No response from server.");
            }
            console.error('Network Error?:', error);
            break;

          default:
            if (error.status >= 500 && error.status < 600) {
              // Server errors
              const errorMessage = error.error?.message || error.message || 'An unexpected error occurred.';
              console.error(errorMessage);
              if (!suppressToast) {
                this.errorMessageService.showTemporaryError("A server error has occurred.", 5000);
              }
            }
            break;
        }

        // Re-throw the error so components can still handle it if needed
        return throwError(() => error);
      })
    );
  }
}
